module.exports = __webpack_public_path__ + "static/dell-d58e04b4865c871d6f598045373da3ff.png";